import React from 'react'

import { Theme } from '@material-ui/core'

import { Container } from '../../../components'
import { useStyles } from '../../../styles/useStyles'
import { typographyStyle } from '../../../theme/typographyStyle'

interface Props {
    theme: Theme
    columns: (string | number | React.ReactNode)[]
    onClickRow: () => void
    nonFlexCells?: number[] // Array of column indices that should not flex
    /** Optional width override per non-flex column index (default 48px) */
    nonFlexCellWidths?: Record<number, string>
}

export const WorkspaceProjectsRow = (props: Props) => {
    const {
        theme,
        columns,
        onClickRow,
        nonFlexCells = [],
        nonFlexCellWidths = {},
    } = props

    const classes = useStyles()

    const getCellStyle = (index: number): React.CSSProperties => {
        const baseStyle = {
            ...typographyStyle(theme.typography.subtitle1),
            fontWeight: 400,
            margin: theme.spacing(0, 0.5),
        }

        if (nonFlexCells.includes(index)) {
            return {
                ...baseStyle,
                flex: '0 0 auto',
                width: nonFlexCellWidths[index] ?? '48px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }
        }

        return {
            ...baseStyle,
            flex: 1,
            justifyContent: 'flex-start',
        }
    }

    return (
        <Container
            style={{
                border: '1px solid',
                borderColor: theme.palette.grey[400],
                borderRadius: '10px',
                flexDirection: 'row',
                padding: theme.spacing(1),
                marginTop: theme.spacing(1),
                cursor: 'pointer',
            }}
            alignItems="center"
            className={classes.hoverGrey300}
            onClick={onClickRow}
        >
            {columns.map((column, index) => {
                return (
                    <Container key={index} style={getCellStyle(index)}>
                        {column}
                    </Container>
                )
            })}
        </Container>
    )
}
